import { render } from "./AddStoresModal.vue?vue&type=template&id=4f238cf8&ts=true"
import script from "./AddStoresModal.vue?vue&type=script&lang=ts"
export * from "./AddStoresModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__